/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginRequest as ModelsLoginRequest } from '../../models/models/login-request';
import { SuccessResponse as ModelsSuccessResponse } from '../../models/models/success-response';

export interface ApiV1AuthLoginPost$Params {
  
    /**
     * Login request
     */
    body: ModelsLoginRequest
}

export function apiV1AuthLoginPost(http: HttpClient, rootUrl: string, params: ApiV1AuthLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1AuthLoginPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSuccessResponse>;
    })
  );
}

apiV1AuthLoginPost.PATH = '/api/v1/auth/login';
